import { render, staticRenderFns } from "./detailsWheelAct.vue?vue&type=template&id=774cf6ff&scoped=true&"
import script from "./detailsWheelAct.vue?vue&type=script&lang=js&"
export * from "./detailsWheelAct.vue?vue&type=script&lang=js&"
import style0 from "./detailsWheelAct.vue?vue&type=style&index=0&id=774cf6ff&lang=scss&scoped=true&"
import style1 from "./detailsWheelAct.vue?vue&type=style&index=1&id=774cf6ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774cf6ff",
  null
  
)

component.options.__file = "detailsWheelAct.vue"
export default component.exports